/**
 * Transition Tokens (Internal Design System)
 *
 * Consistent timing values for animations and transitions.
 */

export const transitions = {
  duration: {
    fast: '0.1s',
    normal: '0.2s',
    slow: '0.3s',
  },
  easing: {
    easeInOut: 'ease-in-out',
    easeOut: 'ease-out',
    easeIn: 'ease-in',
  },
} as const

export const toastDurations = {
  short: 4000,
  default: 6000,
  long: 10000,
} as const

export type Transitions = typeof transitions
export type ToastDurations = typeof toastDurations
